var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e1cc0000-0000-0000-0000-e1cc00000000",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-e1cc0000-0000-0000-0000-e1cc00000001 {\n        fill: #2c2c2c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e1cc0000-0000-0000-0000-e1cc00000001",
    d: "M1248,96c52.94,0,96,43.06,96,96v1536c0,52.94-43.06,96-96,96H192c-52.94,0-96-43.06-96-96V192c0-52.94,43.06-96,96-96h1056M1248,0H192C85.96,0,0,85.96,0,192v1536c0,106.04,85.96,192,192,192h1056c106.04,0,192-85.96,192-192V192c0-106.04-85.96-192-192-192h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e1cc0000-0000-0000-0000-e1cc00000001",
    d: "M469,639.84 L945,639.84 L945,789.84 L619,789.84 L619,885 L945,885 L945,1035 L619,1035 L619,1130.16 L945,1130.16 L945,1280.16 L469,1280.16 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEIcon);
export default __webpack_public_path__ + "static/media/EIcon.6a6191b6f20e7dc206840aba3b1621f4.svg";
export { ForwardRef as ReactComponent };